import * as React from 'react';

const Subtitle = ({ children }) => <div className="subtitle">{children}</div>;

export default Subtitle;
